import React, { useMemo, useState, useRef, useEffect, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react';
// @ts-ignore CSS is loaded by the application bundler.
import 'ag-grid-community/styles/ag-grid.css';
// @ts-ignore CSS is loaded by the application bundler.
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { FaUser, FaBuilding, FaGlobe, FaArrowUp, FaCogs, FaIndustry } from 'react-icons/fa';
import SearchBar from '../../SearchBarTable/SearchBarTable';
// @ts-ignore CSS is loaded by the application bundler.
import "../AgGridTheme.css";
import SortHeader from '../SortingHeader';
import {
  ClientSideRowModelModule,
  ModuleRegistry,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule
} from "ag-grid-community";
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule,
]);
interface ParticipantTableProps {
  participants: any[];
  onEditParticipant: (participantName: string) => void;
  onRowSelect: (participant: any) => void;
  onClearSelection: () => void;
  selectedRow: string | null;
}

const ParticipantTable: React.FC<ParticipantTableProps> = ({
  participants,
  onEditParticipant,
  onRowSelect,
  onClearSelection,
  selectedRow,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [gridApi, setGridApi] = useState<any>(null);
  const gridRef = useRef<AgGridReact>(null);

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
  };
 
  // const handleSearchChange = (query: string) => {
  //   setSearchQuery(query);
  //   if (gridApi) {
  //     gridApi.setQuickFilter(query);
  //   }
  // };
  
  const filteredParticipants = useMemo(() => {
    const lowerSearchQuery = searchQuery.toLowerCase();
    return participants.filter(group =>
      group.participant_name?.toLowerCase().includes(lowerSearchQuery) ||
      group.account_name?.toLowerCase().includes(lowerSearchQuery) ||
      group.iso_code?.toLowerCase().includes(lowerSearchQuery) ||
      group.company_name?.toLowerCase().includes(lowerSearchQuery) ||
      group.asset_name?.toLowerCase().includes(lowerSearchQuery) ||
      group.iso_resource_name?.toLowerCase().includes(lowerSearchQuery) 
    );
  }, [participants, searchQuery]);

  
  const columnDefs = useMemo(
    () => [
      {
        headerName: "Participant",
        field: "participant_name",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Participant',
          enableSorting: true,
          icon: <FaUser className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
      {
        headerName: "Company",
        field: "company_name",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Company',
          enableSorting: true,
          icon: <FaBuilding className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
      {
        headerName: "ISO",
        field: "iso_code",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'ISO',
          enableSorting: true,
          icon: <FaGlobe className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
      {
        headerName: "Asset Name",
        field: "asset_name",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Asset Name',
          enableSorting: true,
          icon: <FaCogs className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
      {
        headerName: "Resource Name",
        field: "iso_resource_name",
        sortable: true, 
        flex: 1,
        minWidth: 250,
        // enableRowGroup: true,
        cellRenderer: (params: any) => (
          <div className="flex items-center gap-2">
            {params.value}
          </div>
        ),
        headerComponent: SortHeader, 
        headerComponentParams: {
          displayName: 'Resource Name',
          enableSorting: true,
          icon: <FaIndustry className="text-gray-600" />
        },
        headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
      },      
    ],
    []
  );

  const defaultColDef = useMemo(() => ({
    // sortable: true,
    // filter: true,
    resizable: true,
    // floatingFilter: true,
    cellStyle: {
      padding: '8px 12px',
      fontSize: '15px',
      fontFamily: "'Poppins', sans-serif",
      color: '#374151',
    },
  }), []);
  useEffect(() => {
    if (gridRef.current && selectedRow !== null) {
      gridRef.current.api.forEachNode((node) => {
        node.setSelected(node.data.participant_name === selectedRow);
      });
    }
  }, [selectedRow]);

  return (
    <div className="participant-table flex-1 bg-white p-5 rounded-tr-xl rounded-bl-xl shadow-xl font-poppins h-auto">
      {/* <div className="flex justify-between items-center space-x-4 mb-4"> */}
      <div className="flex justify-between items-center mb-4">
           <div className="flex items-center bg-gray-200 px-3 py-2 rounded-full  max-w-md">
        <SearchBar
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
          placeholder="Search participants..."
        />
      </div>
      </div>

      <div className="ag-theme-alpine font-poppins text-base text-gray-700" style={{ height: "var(--admin-tab-grid-height, max(475px, calc(100dvh - 320px)))", width: "100%",overflow:'auto', border: '1px solid #E7E4FF', borderRadius: '8px'}}>
        <AgGridReact
          theme="legacy"
          ref={gridRef}
          rowData={filteredParticipants}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          domLayout="normal"
          rowHeight={60}
          headerHeight={55}
          // floatingFiltersHeight={55}
          pagination={true}
          paginationPageSize={50}
          // rowGroupPanelShow="always"
          // groupDisplayType="multipleColumns"
          className="ag-theme-alpine"
          suppressRowHoverHighlight={false}
          // columnHoverHighlight={true}
          onGridReady={(params) => setGridApi(params.api)}
          onRowClicked={(event) => onRowSelect(event.data)}
          getRowClass={(params) =>
            params.data.participant_name === selectedRow ? 'bg-gray-200' : ''
          }
        />
      </div>
          </div>
  );
};

export default ParticipantTable;
